import { FOCUS_ELEMENT_ACTIONS, UNFOCUS_ELEMENT_ACTIONS } from '../actions/focusActions';

const initial_state = {
  focused: false,
  elem: null
};

export const focusReducer = (state = initial_state, action) => {
  switch (action.type) {
    case FOCUS_ELEMENT_ACTIONS:
      return  {...state, focused: true, elem: action.elem};
    case UNFOCUS_ELEMENT_ACTIONS:
      return {...state, focused: false, elem: null};
    default: 
      return {...state};
  }
};